import { render, staticRenderFns } from "./AccountSwitch.vue?vue&type=template&id=b2551bca&"
import script from "./AccountSwitch.vue?vue&type=script&lang=js&"
export * from "./AccountSwitch.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./AccountSwitch.vue?vue&type=style&index=1&id=b2551bca&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports